import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type FaxRelativePath =
  | '/inbox'
  | '/drafts'
  | '/archived'
  | '/contacts'
  | '/blocked'
  | '/drafts/new'
  | '/drafts/new-from-template';

export const featureDefinition = {
  root: '/fax',
  iconName: 'fax',
  items: {
    '/inbox': {
      label: 'Fax Inbox',
      trackingId: 'fax-nav-inbox',
      description:
        'Central location for all incoming and outgoing faxes. View, tag, archive, and further manage received fax documents in a single interface.',
    },
    '/drafts': {
      label: 'Drafts',
      trackingId: 'fax-nav-drafts',
      description: 'Collection of unsent or paused fax transmissions. Edit details or send these faxes when ready.',
    },
    '/archived': {
      label: 'Archived',
      trackingId: 'fax-nav-archived',
      description:
        'Archived fax history for record-keeping. Preserves older fax communications outside the main inbox.',
    },
    '/contacts': {
      label: 'Fax Contacts',
      trackingId: 'fax-nav-contacts',
      description:
        'Manage contact information specifically for faxing. Add or remove fax numbers and relevant details.',
    },
    '/blocked': {
      label: 'Blocked',
      trackingId: 'fax-nav-blocked',
      description: 'List of blocked fax numbers to prevent unwanted inbound or outbound fax traffic.',
    },
    '/drafts/new': {
      label: 'Send New Fax',
      trackingId: 'fax-nav-send-new-fax',
      description:
        'Initiate a new fax transmission by uploading documents, selecting recipients, and adding a cover sheet.',
      show: false,
    },
    '/drafts/new-from-template': {
      label: 'Send From Template',
      trackingId: 'fax-nav-send-from-template',
      description:
        'Quickly prepare a new fax using predefined templates to streamline repetitive or common transmissions.',
      show: false,
    },
  },
} as const satisfies FeatureDefinitionGroup<'/fax', 'fax', FaxRelativePath>;

export const featureExtractionVisibility = {} as const satisfies FeatureExtractionVisibility<FaxRelativePath>;
